import angular from 'angular';
import employeeDetailsComponent from './employee-details.component';

let employeeDetailsModule = angular.module('employeeDetails', [
])

.config(($stateProvider, $urlRouterProvider) => {
  "ngInject";
})

.component('employeeDetails', employeeDetailsComponent);

export default employeeDetailsModule;



// WEBPACK FOOTER //
// ./client/pages/admin/employee-details/employee-details.js